import { format } from "date-fns";

export const formatStringDateTime = (
    date: string,
    formatString = "dd/MM/yyyy HH:mm",
) => {
    try {
        return format(new Date(date), formatString);
    } catch {
        return date;
    }
};
